$(document).ready(function() {
    const $staffImages = $("#staffImages");
    if($staffImages.length) {
        $staffImages.slick({
            infinite: false,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            variableWidth: true,
            swipeToSlide: true
        });
    }

    const $staffImagesPhotos = $(".staff-images__photos");
    if($staffImagesPhotos.length) {
        $staffImagesPhotos.slick({
            draggable: false,
            swipe: false,
            touchMove: false,
            prevArrow: '<button class="photo-arrow photo-prev"><span class="photo-arrow-icon"></span></button>',
            nextArrow: '<button class="photo-arrow photo-next"><span class="photo-arrow-icon"></span></button>',
            lazyLoad: 'ondemand',
        });

        const lightbox = GLightbox({
            touchNavigation: true,
            loop: false,
            closeButton: true
        });
    }
});